import { Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BackButton } from '../components/BackButton'
import ContactCard from '../components/ContactCard'
import { PageContainer } from '../components/layout/PageContainer'
import YesNoAction from '../components/YesNoAction'
import {
  selectAllFarmerAccounts,
  selectContactInfo,
  selectCurrentFarmerAccount,
} from '../features/azure-b2c/storage'
import { TestIds } from '../testIds'

export const DeleteAccountSuccess = () => {
  const farmlandsAccounts = useSelector(selectAllFarmerAccounts)
  const currentAccount = useSelector(selectCurrentFarmerAccount)
  const navigate = useNavigate()

  const relationshipOwner = useSelector(selectContactInfo)

  const [account, setAccount] = useState<string | undefined>()

  useEffect(() => {
    if (!account) {
      setAccount(currentAccount?.accountNumber)
    } else if (account !== currentAccount?.accountNumber) {
      navigate('/account')
    }
  }, [currentAccount])

  return (
    <PageContainer data-testid={TestIds.pages.cart}>
      <BackButton text='Your Account' onClick={() => navigate('/account')} />
      <>
        <YesNoAction
          display='Request Received'
          subheading={
            <Typography variant='h4' sx={{ mt: 4, mb: 2 }}>
              Removal of FarmlandsPRO account
            </Typography>
          }
          body={
            <Typography variant='body2'>
              Thank you for your request, {farmlandsAccounts?.contactFirstName}. Your request has
              been forwarded to our customer services team and will be actioned within the next 48
              hours. Please note that your Farmlands shareholding account will remain active.
            </Typography>
          }
        />
        <ContactCard
          sx={{ mt: 4 }}
          title='If you have any questions please contact your Farmlands representative.'
          data-testid={TestIds.components.contactCard.card}
          {...relationshipOwner}
        />
      </>
    </PageContainer>
  )
}
